import AccessControlPill from "@/components/Atoms/Pills/AccessControlPill";
import TagPill_1 from "@/components/Atoms/Tags/TagPill_1";
import getTagDevIconName from "@/utils/frontend/getTagDevIconName";
import { getEntityLocationStr, humanizeString } from "@/utils/frontend/stringOps";

const TalentPreviewCard = ({ data, tags=[], callback, onClick, selectedId, roundedTopBottomCorners, href, lang }) => {

  // console.log('data@talentpreviewcard', data)
  return (
    // <div className="m-0 cursor-pointer">
    //   <div className="w-full bg-inherit justify-center mx-auto dark:border-gray-800">
    //     <div className={`rounded-lg ${Number(selectedId) === Number(data.id) ? 'bg-gray-200 dark:bg-gray-950 border-black dark:border-gray-600' : 'bg-white'} transition duration-300 py-3 dark:bg-gray-900 hover:bg-gray-200 dark:hover:bg-gray-950 shadow-lg relative h-full relative`}>
    //       <div className="p-4 h-full flex flex-col flex-grow justify-between">
    <div className="m-0 h-full flex flex-col">
    <div className="w-full bg-inherit justify-center mx-auto dark:border-gray-800 h-full ">
      <div className={`rounded-xl bg-white transition duration-300 py-3 dark:bg-gray-900 shadow-lg flex flex-col h-full`}>
        <div className="p-4 h-full flex flex-col flex-grow justify-between">
            <div>
              <div className="flex justify-center mb-2 ">

                <img className="object-cover h-20 w-20 rounded-full border-4" src={`https://api.dicebear.com/8.x/identicon/svg?seed=${data.talent_pseudonym}?randomizeIds=true`} />
              </div>
              <div className="text-center">
                <h3 className="font-bold text-sm text-black dark:text-white leading-8 whitespace-nowrap overflow-hidden">
                  {data.talent_pseudonym}
                </h3>
                <div className="dark:text-white text-sm -mt-1">{data[`talent_job_title_${lang}`]}</div>
                <p className={`text-sm text-black dark:text-white dark:text-gray-300 whitespace-nowrap overflow-hidden`}>
                    {/* {humanizeString(data.talent_location_country)} {humanizeString(data.talent_location_state)} {humanizeString(data.talent_location_city)} */}
                    {/* {humanizeString([data.talent_location_country, data.talent_location_state, data.talent_location_city].filter(Boolean).join(', '))} */}
                    {data.talent_location?.label}
                </p>
              </div>
              <div className="text-center mt-2" key='level1tags'>
                {tags.map(tag => {
                  return tag && tag.tag_level === 1 && <span key={tag.id}><TagPill_1 bgColors={'bg-gray-100 dark:bg-gray-800'} tagType='PRIMARY' iconName={getTagDevIconName(tag[`tag_name_en`])} caption={tag[`tag_name_${lang}`]} /></span>
                })}
              </div>
              <div className="text-center mt-2" key='level2tags'>
                {tags.map(tag => {
                  return tag && tag.tag_level === 2 && <span key={tag.id}><TagPill_1 bgColors={'bg-gray-100 dark:bg-gray-800'} tagType='SECONDARY' iconName={getTagDevIconName(tag[`tag_name_en`])} caption={tag[`tag_name_${lang}`]} /></span>
                })} 
              </div>
              
              <div className="text-center mt-6">
              {data.talent_sector_industry && <div className={`flex gap-1 flex-wrap justify-center text-center text-xs font-inter mt-2`}>
               {/* {console.log(data.talent_sector_industry)} */}
                         {/* {data.talent_sector_industry.map(x=>  */}
                   
                              <span className="whitespace-nowrap px-2 py-1 border text-slate-500
dark:text-slate-300 rounded border-slate-400 dark:border-slate-600 ">{
     data.talent_sector_industry.label_en ? data.talent_sector_industry[`label_${lang}`]:JSON.parse(data.talent_sector_industry)[`label_${lang}`]
     }</span>
                    
                         {/* )} */}
                    </div>}
              </div>
            </div>
          {data?.talent_access_control && <div className="mt-6">
            <AccessControlPill data={data} lang={lang}/>
 </div>}

         {data.talent_resume && <div className="mt-6 dark:text-white">
            {data.talent_resume[lang]}
 </div>}


          </div>
          
        </div>
        
      </div>
    </div>
  );
};

export default TalentPreviewCard;

// import TagPill_1 from "@/components/Atoms/Tags/TagPill_1";
// import getTagDevIconName from "@/utils/frontend/getTagDevIconName";

// const TalentSmallCard_2 = ({ data, callback, onClick, selectedId, roundedTopBottomCorners, href, lang }) => {
//   console.log("TALENTSMALLRCARDDATA", data)
//   return (
//     <div className="m-0 cursor-pointer">
//       <div className="w-full bg-inherit justify-center mx-auto dark:border-gray-800 mb-1">
//         <div className={`rounded-lg ${Number(selectedId) === Number(data.id) ? 'bg-gray-200 dark:bg-gray-950 border-black dark:border-gray-600' : 'bg-white'} transition duration-300 py-3 dark:bg-gray-900 hover:bg-gray-200 dark:hover:bg-gray-950 shadow-lg h-96`}>
//           <div className="p-4">
//             <div className="flex justify-center mb-2">
//               <img className="object-cover h-20 w-20 rounded-full border-4" src={`https://api.dicebear.com/8.x/identicon/svg?seed=${data.talent_pseudonym}?randomizeIds=true`} />
//             </div>
//             <div className="text-center">


//               <h3 className="font-bold text-sm text-black dark:text-white leading-8 whitespace-nowrap overflow-hidden">
//               {data.talent_access_control.talent_is_private ? <i className="mr-1 fa-solid fa-lock text-red-600 text-lg"></i> : <i className="mr-1 fa-solid fa-unlock text-green-600 text-lg"></i>}
//              {data.talent_pseudonym}

//               </h3>
//               <div className="dark:text-white text-sm -mt-1">{data.talent_job_title[lang]}</div>
//               <p className={`text-sm text-black dark:text-white dark:text-gray-300 whitespace-nowrap overflow-hidden`}>{data.talent_location}</p>
//             </div>
//             <div className="text-center mt-2">
//             {data.tags.map(tag=> {return tag.tag_type === 'PRIMARY' && <span key={tag.id}><TagPill_1 bgColors={'bg-gray-100 dark:bg-gray-800'} tagType='PRIMARY' iconName={getTagDevIconName(tag.tag_name)} caption={tag.tag_name}/></span>})}
//             </div>
//             <div className="text-center mt-2">
//             {data.tags.map(tag=> {return tag.tag_type === 'SECONDARY' && <span key={tag.id}><TagPill_1 bgColors={'bg-gray-100 dark:bg-gray-800'} tagType='SECONDARY' iconName={getTagDevIconName(tag.tag_name)} caption={tag.tag_name}/></span>})}
//             </div>

//             <div className="relative top-24 z-20 flex space-x-4 text-center">test</div>
            
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TalentSmallCard_2;
